.header {
  width: 100%;
  margin: 0;
  padding: 2px;
  border-bottom: 1px solid grey;
  background-color: bisque;
  color: #444;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  text-align: right;
}
.header a,
.header a:visited,
.header a:hover {
  text-decoration: none;
  color: #444;
}
.header a.this-page:before {
  content: "❧\00a0";
}
.header a,
.header span {
  margin-right: 0.5em;
}
.header a.this-page {
  font-weight: bold;
}
